/* eslint-disable react/require-default-props */
// @flow

import { rem } from 'polished';
import cx from 'classnames';
import React, { PureComponent, type Node } from 'react';
import styled from 'styled-components';

import Translate from 'client/components/translate';
import COLORS, { HEX_TRANSPARENT } from 'client/constants/colors';
import Ribbon from 'client/components/plan/card/ribbon';
import 'client/styles/planCard.scss';

const CompactAppCardContainer = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: ${rem(12)};
  box-shadow: 0 ${rem(2)} ${rem(10)} 0 ${`${COLORS.GRAY_7}${HEX_TRANSPARENT[50]}`};
  color: ${COLORS.NEUTRAL_900};
  cursor: ${props => (props.isClickable ? 'pointer' : 'default')};
  letter-spacing: 0;
  padding-bottom: 1.5rem;
  img {
    margin-right: ${rem(10)};
    max-height: 1.5rem;
    min-width: ${rem(29)};
  }
`;

const CompactRibbonContainer = styled.div`
  padding-top: 0.5rem;
  text-align: right;
`;

const determineStatusColor = (status) => {
  switch (status) {
    case 'waiting':
      return COLORS.STRIDE_ORANGE;
    case 'cancelled':
      return COLORS.GRAY_3;
    case 'gtg':
      return COLORS.STRIDE_ELETRIC_GREEN;
    default:
      return COLORS.BRAND_50;
  }
};

const SubmittedContainer = styled.div`
  color: ${props => determineStatusColor(props.status)};
  font-size: ${rem(10)};
  padding-right: ${rem(10)};
  font-weight: 600;
`;

type Props = {
  children?: Node | null,
  className: string,
  isCard: boolean,
  isCompactView: boolean,
  isClickable: boolean,
  status: {
    content: string,
    classes: Object,
  } | null,
  submittedDate?: string | null,
};

export default class PlanCard extends PureComponent<Props> {
  static defaultProps = {
    children: null,
    className: '',
    isCard: false,
    isCompactView: false,
    isClickable: true,
    status: null,
  };

  render() {
    const { children, className, isCard, isClickable, isCompactView, status, submittedDate } =
      this.props;
    return (
      <div className={cx('plan-card', { wrapped: isCard }, className)}>
        {isCompactView ? (
          <CompactAppCardContainer isClickable={isClickable}>
            {status && (
              <CompactRibbonContainer>
                {submittedDate ? (
                  <SubmittedContainer status={status.classes.className}>
                    <Translate
                      using={{ date: submittedDate }}
                      path="common.healthDetails.planSubmittedDate" />
                  </SubmittedContainer>
                ) : null}
                <Ribbon
                  classes={status.classes}
                  content={status.content}
                  isCompactRibbon
                  wrapAround />
              </CompactRibbonContainer>
            )}
            {children}
          </CompactAppCardContainer>
        ) : (
          <div className="row card-top-padding" style={{ position: 'relative' }}>
            {status && (
              <div className="ribbon-container">
                <Ribbon content={status.content} classes={status.classes} wrapAround={isCard} />
              </div>
            )}
            {children}
          </div>
        )}
      </div>
    );
  }
}
